// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".getCode[data-v-bbc0e07a]{text-align:center;height:5.333vw;line-height:5.333vw;font-size:1.6vw}", ""]);
// Exports
module.exports = exports;
